import React from 'react';
import { SectionLayout } from '@/components/section-layout';

export function ReportsPage() {
  return (
    <SectionLayout title="Reports">
      {/* Reports content will go here */}
    </SectionLayout>
  );
} 